import React, {FunctionComponent} from 'react'
import './TopBar.css'
import {Link} from "react-router-dom";
import LoginDialog from "./login-dialog";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../reducers/current-user-reducer";
import {doLogout} from "../store/system-actions";
import {RootState} from "../reducers/root-reducer";
import {SHOW_LOGIN_MODAL} from "../store/modal-action-types";

export const TopBar: FunctionComponent = () => {

    let {user, userCheckState} = useSelector<RootState, AppState>(s => s.appState)

    const dispatch = useDispatch()

    function onSigninClick() {
        dispatch({type: SHOW_LOGIN_MODAL})
    }

    function onSignoutClick() {
        dispatch(doLogout())
    }


    return (
        <>
            <div className="top-bar">
                <span className='brand'>GiveMeThatPicture</span>


                <button className="sign-up">
                    <Link to="/trending">
                        Trending
                    </Link>
                </button>


                {userCheckState === 'not_logged' && <>
                    <button className="sign-up">
                        <a href="/" style={{cursor: "pointer"}}>Sign up</a>
                    </button>
                    <button className="sign-up" onClick={onSigninClick}>Sign in</button>
                </>}
                {(userCheckState === 'logged' && user) && <>
                    {/*<CircularImage imageLink={user.profilepicture} style={{}} />*/}
                    <button>{user.fname} {user.lname}</button>
                    <button className="sign-up" onClick={onSignoutClick}>Sign out</button>
                </>}
            </div>
            <LoginDialog />
        </>
    )
}